export default __webpack_public_path__ + "static/insfocus_medium_2-62e83bafa9ff5f8b8b896b9643e44475.jpg";